import styled from "@emotion/styled";
import { Box } from '@mui/material';

export const SupportContentStyled = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const LinkBoxStyled = styled(Box)`
& > * {
  margin-bottom: 15px;
  margin-up: 15px;
}
`;